import React from 'react'
import RoomSchedule from 'frontend/schedule/room-schedule'
import RoomWeekSelect from 'frontend/schedule/room-week-select'
import CommonIcons from 'frontend/components/common-icons'

export default class OnlineRoomSchedule extends RoomSchedule {
  renderFilters () {
    return (
      <div className="filters">
        <div className="select_date">
          <h4 className="title">
            <span className="fix_title">Select date and time</span>
          </h4>
          <RoomWeekSelect
            selected={this.state.selectedDate}
            onChange={this.handleDateSelect.bind(this)}
          />
        </div>
      </div>
    )
  }

  renderHelpers () {
    const { schedule: { minPlayers, maxPlayers } } = this.state

    return (
      <div className="helpers">
        <div className="no_strangers_notice helper">
          <CommonIcons item="common-user-secret" className="icon" />
          *All games are private, only your team is allowed in the room, NO&nbsp;STRANGERS.
        </div>

        <div className="game_cost helper">
          <CommonIcons item="common-calendar-alt-r" className="icon" />
          <div className="label">Wednesday - Sunday</div>
          <div className="value">$115 2-4 connections</div>
          <div className="value">$15 each additional</div>
        </div>

        <div className="players_count helper">
          <CommonIcons item="common-users" className="icon" />
          <div className="value">{minPlayers}&ndash;{ maxPlayers} Connections</div>
        </div>
      </div>
    )
  }
}
